import api from "./API";
import ApiEndpointConstants from "../constants/ApiEndpointConstants";

export const getTieZi = (id) => {
  return api.post(`${ApiEndpointConstants.GET_TIEZI}`, { id });
};
